import React, { useContext } from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import useWindowSize from '@components/common/hooks/useWindowSize';
import { M_DEVICE } from '@components/lpc/Constants';
import UserContext from '@components/lpc/Context/User/UserContext';

import css from './SubNav.module.scss';

const SubNav = () => {
    const { t } = useTranslateLpc('lpc-solidarity-page');
    const userContext = useContext(UserContext);
    const { userAccount } = userContext;
    const { width } = useWindowSize();

    const shouldOffset = userAccount?.showMustCollectMoneyBanner && width > M_DEVICE;

    return (
        <div className={`${css.nav_container} ${shouldOffset ? css.nav_container_offset : ''}`}>
            <div className={css.nav_container__title}>{t('nav.title')}</div>
            <div className={css.nav_container__tab_link}>{t('nav.link-1')}</div>
        </div>
    );
};
export default SubNav;
